import { Col, Row } from "react-styled-flexboxgrid";
import styled from "styled-components";
import { useAuthContext } from "../../contexts/AuthContext";
import { useTranslationContext } from "../../contexts/TranslationContext";

import Box from "../Global/Atomics/Box";
import { LinkButton } from "../Global/Atomics/Button";
import { Container } from "../Global/Atomics/Container";
import { Heading } from "../Global/Atomics/Heading";
import NovaCircle from "../Global/Atomics/NovaCircle";
import { Paragraph } from "../Global/Atomics/Paragraph";
import CustomIcon from "../Global/Icons/CustomIcon";

const StyledMiddleBox = styled(Box)`
    position: absolute;
    width: 100%;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
`;

export const NoMatch = ({ redirectPath = '/home' }) => {
    const { user } = useAuthContext();
    const { resources } = useTranslationContext();
    
    let href = '/';
    const sessionToken = localStorage.getItem('sessionToken');
    if (user || sessionToken) {
        href = redirectPath
    }

    return (
        <>
            <NovaCircle size={158} customPosition="top-right" zIndex={1000} customColor="neutral0.5" />
            <StyledMiddleBox>
                <Container>
                    <Row center="xs">
                        <Col xs={9}>
                            <Box display="flex" flexDirection="column" alignItems="center">
                                <Box mb="md">
                                    <CustomIcon icon="PageNotFound" />
                                </Box>

                                <Heading level={1} typography="text-l-bold" mt="lg" mb="sm" textAlign="center">{resources.noMatch.title}</Heading>
                                <Paragraph typography="text-s-medium" textAlign="center" mb="lg">{resources.noMatch.description}</Paragraph>

                                <LinkButton to={href} size="s" variant='primary-black'>{resources.noMatch.ctaText}</LinkButton>
                            </Box>
                        </Col>
                    </Row>
                </Container>
            </StyledMiddleBox>
        </>
    );
};
